import * as React from "react";
import images from "./assets/images";

const BrandsSection: React.FC = () => {
  return (
    <div className="relative md:pb-[250px] pb-0">
      {" "}
      {/* Adăugăm padding bottom doar pe ecrane md și mai mari */}
      <p className="text-center text-2xl font-ubuntu mb-8 mt-8">Brands We ♡</p>
      <div className="relative flex flex-col items-center space-y-6 z-[1]">
        {/* Primul rând - 4 drone */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-[9px]">
          {/* Autel */}
          <div className="flex flex-col items-center">
            <img
              src={images.autel}
              alt="Autel"
              className="w-[279px] h-auto" // Setăm lățimea pentru imaginea dronei
            />
            <img
              src={images.autelLogo}
              alt="Autel Logo"
              className="mt-4 w-[124px] h-auto" // Setăm lățimea pentru logo
            />
          </div>

          {/* DJI */}
          <div className="flex flex-col items-center">
            <img
              src={images.dji}
              alt="DJI"
              className="w-[279px] h-auto" // Lățimea dronei
            />
            <img
              src={images.djiLogo}
              alt="DJI Logo"
              className="mt-4 w-[124px] h-auto" // Lățimea logo-ului
            />
          </div>

          {/* GoPro */}
          <div className="flex flex-col items-center">
            <img
              src={images.goPro}
              alt="GoPro"
              className="w-[279px] h-auto" // Lățimea dronei
            />
            <img
              src={images.goProLogo}
              alt="GoPro Logo"
              className="mt-4 w-[124px] h-auto" // Lățimea logo-ului
            />
          </div>

          {/* Parrot */}
          <div className="flex flex-col items-center">
            <img
              src={images.parrot}
              alt="Parrot"
              className="w-[279px] h-auto" // Lățimea dronei
            />
            <img
              src={images.parrotLogo}
              alt="Parrot Logo"
              className="mt-4 w-[124px] h-auto" // Lățimea logo-ului
            />
          </div>
        </div>

        {/* Al doilea rând - 3 drone centrate */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-[9px] justify-center">
          {/* PowerVision */}
          <div className="flex flex-col items-center">
            <img
              src={images.powerVision}
              alt="PowerVision"
              className="w-[279px] h-auto" // Lățimea dronei
            />
            <img
              src={images.powerVisionLogo}
              alt="PowerVision Logo"
              className="mt-4 w-[124px] h-auto" // Lățimea logo-ului
            />
          </div>

          {/* Ubsan */}
          <div className="flex flex-col items-center">
            <img
              src={images.ubsan}
              alt="Ubsan"
              className="w-[279px] h-auto" // Lățimea dronei
            />
            <img
              src={images.ubsanLogo}
              alt="Ubsan Logo"
              className="mt-4 w-[124px] h-auto" // Lățimea logo-ului
            />
          </div>

          {/* Yuntec */}
          <div className="flex flex-col items-center">
            <img
              src={images.yuntec}
              alt="Yuntec"
              className="w-[279px] h-auto" // Lățimea dronei
            />
            <img
              src={images.yuntecLogo}
              alt="Yuntec Logo"
              className="mt-4 w-[124px] h-auto" // Lățimea logo-ului
            />
          </div>
        </div>
      </div>
      {/* Imaginea decorativă, ascunsă pe tablete și telefoane */}
      <img
        src={images.decoration}
        alt="Decoration"
        className="hidden md:block absolute bottom-0 left-0 w-full h-auto object-cover"
      />
    </div>
  );
};

export default BrandsSection;
